<template>
  <div class="card906">
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="blob"></div>
    <div class="card906-content" data-slot="default">
      <slot>
        <div class="row justify-content-center align-items-center p-5">
          <div class="col-lg-6">
            <h1>aslkdmlkasmd</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque cupiditate dolores ea enim est facilis
              hic
              iure, libero nulla praesentium saepe, veritatis voluptatum! Aliquid facere nihil quas, similique sint
              sit!</p>
          </div>
          <div class="col-lg-6 text-center">
            <img src="https://api.mixitweb.com/storage/assets/steptodown.com658168.jpg" style="height: 250px;"
                 class="mx-auto text-center" alt="">
          </div>
        </div>
      </slot>
    </div>

  </div>
</template>

<script>
export default {
  name: "Card906"
}
</script>

<style scoped>
.card906 {
  position: relative;
  width: 100%;
  height: 450px;
  background: lightgrey;
  z-index: 1;
  border-radius: 21px;
  overflow: hidden;
}

.card906-content {
  background: linear-gradient(rgba(255, 255, 255, 0.473), rgba(150, 150, 150, 0.25));
  z-index: 1;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 15px;
}

.card906-content {
  z-index: 1;
}

.card906 .blob {
  position: absolute;
  z-index: -1;
  border-radius: 100%;
  width: 350px;
  height: 350px;
}

.card906 .blob:nth-child(2) {
  left: -50px;
  top: -90px;
  background: var(--primary);
}

.card906 .blob:nth-child(3) {
  left: 110px;
  top: -20px;
  z-index: -1;
  background: var(--secondary);
}

.card906 .blob:nth-child(4) {
  left: -40px;
  top: 100px;
  background: var(--primary);
}

.card906 .blob:nth-child(5) {
  left: 100px;
  top: 180px;
  background: var(--secondary);
}

.card906 .blob:nth-child(6) {
  left: -22px;
  top: 233px;
  background: var(--primary);
}


</style>